import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { setupPwa } from './lib/pwa.js';
import './styles/stage.css';
import './styles/app.css';

/**
 * Registra o service worker — **menos no /telao**.
 *
 * A TV é 100% rede de propósito: navegador de smart TV é frágil, e um shell
 * em cache numa TV ligada há semanas é o pior lugar para descobrir um bug.
 * Ver o cabeçalho de `sw.ts`.
 */
setupPwa();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
